
import axios from 'axios';
import DefaultData from '../../CompanyData/DefaultData';
import config from './APIConfig';

// Extract tenant from hostname — same logic as TenantContext
// No sessionStorage, no race condition
// const getTenantId = () => {
//   let host = window.location.hostname.toLowerCase();

//   if (host.startsWith("www.")) {
//     host = host.replace("www.", "");
//   }

//   // If running on localhost, always use trawtel
//   if (host.startsWith("localhost")) {
//     return "trawtel";
//   }

//   // Otherwise use the subdomain/domain prefix
//   return host.split(".")[0];
// };
const getTenantId = () => {
  let host = window.location.hostname.toLowerCase();
  if (host.startsWith('www.')) host = host.replace('www.', '');
  return host.startsWith('localhost')
    ? 'ZoBookAi'
    : host.split('.')[0];
};

const axiosInstance = axios.create({
  baseURL: DefaultData.APIACTIVEURL,
});

axiosInstance.interceptors.request.use((cfg) => {
  cfg.headers['X-Tenant-ID'] = getTenantId();

  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    cfg.headers.Authorization = `Bearer ${accessToken}`;
  }
  return cfg;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    if (err.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('No refresh token');

        const response = await axios.post(
          DefaultData.APIACTIVEURL + 'auth/refresh',
          { refreshToken }
        );

        const { accessToken, refreshToken: newRefreshToken } = response.data;
        setTokens({ accessToken, refreshToken: newRefreshToken });

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshErr) {
        console.error('Token refresh failed:', refreshErr);
        clearTokens();
      }
    }
    return Promise.reject(err);
  }
);

export const setTokens = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem('accessToken', accessToken);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export default axiosInstance;